import { Navigate, Route, Routes } from 'react-router-dom';

import type { Route as AppRoute } from '@api/app_context/types';

import Sidebar from '../../layouts/Sidebar';

import { getWorkspacePage } from './utilities/helpers';

const Workspace = ({ route }: { route: AppRoute }) => (
  <Sidebar route={route}>
    <Routes>
      {route.routes?.map((route) => (
        <Route element={getWorkspacePage(route)} key={route.id} path={route.path} />
      ))}
      <Route element={<Navigate replace to={route.routes[0]?.path} />} path="*" />
    </Routes>
  </Sidebar>
);

export default Workspace;
